export class SubmittedJobsTableModel {
  constructor() {
    this.fileName = '';
    this.videoId = '';
    this.transcodingSpeed = '';
    this.uploadTimestampDate = '';
    this.uploadTimestampTime = '';
    this.completion = '';
    this.uploader = '';

    this.id = '';
    this.index = '';
  }
}

export class RunningJobsTableModel {
  constructor() {
    this.fileName = '';
    this.videoId = '';
    this.transcodingSpeed = '';
    this.transcodingStartDate = '';
    this.transcodingStartTime = '';
    this.uploadTimestampDate = '';
    this.uploadTimestampTime = '';
    this.completion = '';
    this.uploader = '';

    this.id = '';
    this.index = '';
  }
}

export class FinishedJobsTableModel {
  constructor() {
    this.fileName = '';
    this.videoId = '';
    this.transcodingSpeed = '';
    this.transcodingEndDate = '';
    this.transcodingEndTime = '';
    this.transcodingStartDate = '';
    this.transcodingStartTime = '';
    this.uploadTimestampDate = '';
    this.uploadTimestampTime = '';
    this.completion = '';
    this.uploader = '';

    this.id = '';
    this.index = '';
  }
}

export class TobeTranscodedJobsTableModel {
  constructor() {
    this.fileName = '';
    this.videoId = '';
    this.uploadTimestampDate = '';
    this.uploadTimestampTime = '';
    this.uploader = '';
    this.completion = '';

    this.payload = new CreateJobModel();
  }
}

export class CreateJobModel {
  constructor() {
    this.fileName = '';
    this.videoId = '';
    this.s3Key = '';
    this.uploadedAt = '';
    this.uploadedBy = '';
  }
}
